module.exports = __webpack_public_path__ + "img/product-1-thumb-5.d0d4470a.jpg";